"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.paintLayer = exports.PaintLayer = exports.paintPhysics = void 0;
exports.drawPaintBalloon = drawPaintBalloon;
exports.createPaintSplatter = createPaintSplatter;
exports.popPaintBalloon = popPaintBalloon;
const paintSplatterShapes_1 = require("./paintSplatterShapes");
const latexBalloon_1 = require("./latexBalloon");
exports.paintPhysics = {
    buoyancy: 25,
    linearDrag: 2.2,
    releaseImpulse: 350,
    collisionRadiusRatio: 0.94
};
function drawPaintBalloon(ctx, balloon) {
    (0, latexBalloon_1.drawLatexVector)(ctx, balloon, { widthRatio: 0.94, opaque: true });
}
/** Pick and transform an authored silhouette once, preserving it between frames. */
function createPaintSplatter(balloon, random = Math.random) {
    return {
        x: balloon.x,
        y: balloon.y,
        color: balloon.color,
        shape: Math.floor(random() * paintSplatterShapes_1.paintSplatterShapes.length),
        rotation: random() * Math.PI * 2,
        scaleX: balloon.radius / 65 * (0.85 + random() * 0.25) * (random() < 0.5 ? -1 : 1),
        scaleY: balloon.radius / 65 * (0.85 + random() * 0.25)
    };
}
const silhouetteCache = new Map();
/** Rasterize each splatter once; memory depends on viewport size, not pop count.
 * Paint lasts until reset or page reload and scales with viewport changes.
 */
class PaintLayer {
    canvas = null;
    width = 0;
    height = 0;
    pending = [];
    add(balloon) {
        this.pending.push(createPaintSplatter(balloon));
    }
    clear() {
        this.pending.length = 0;
        if (this.canvas) {
            const ctx = this.canvas.getContext('2d');
            if (ctx) {
                ctx.save();
                ctx.setTransform(1, 0, 0, 1, 0, 0);
                ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                ctx.restore();
            }
        }
    }
    draw(ctx, width, height, dpr) {
        if (width <= 0 || height <= 0)
            return;
        if (!this.canvas && this.pending.length === 0)
            return;
        const retainedWidth = Math.max(width, this.width);
        const retainedHeight = Math.max(height, this.height);
        const pixelWidth = Math.max(1, Math.round(retainedWidth * dpr));
        const pixelHeight = Math.max(1, Math.round(retainedHeight * dpr));
        if (!this.canvas || this.canvas.width !== pixelWidth || this.canvas.height !== pixelHeight) {
            const resized = document.createElement('canvas');
            resized.width = pixelWidth;
            resized.height = pixelHeight;
            const resizedCtx = resized.getContext('2d');
            if (!resizedCtx)
                return;
            if (this.canvas)
                resizedCtx.drawImage(this.canvas, 0, 0, this.width * dpr, this.height * dpr);
            this.canvas = resized;
        }
        this.width = retainedWidth;
        this.height = retainedHeight;
        const paint = this.canvas.getContext('2d');
        if (!paint)
            return;
        paint.setTransform(pixelWidth / this.width, 0, 0, pixelHeight / this.height, 0, 0);
        for (const splatter of this.pending) {
            paint.save();
            paint.translate(splatter.x, splatter.y);
            paint.rotate(splatter.rotation);
            paint.scale(splatter.scaleX, splatter.scaleY);
            paint.fillStyle = splatter.color;
            paint.globalAlpha = 0.88;
            let silhouette = silhouetteCache.get(splatter.shape);
            if (!silhouette) {
                silhouette = new Path2D(paintSplatterShapes_1.paintSplatterShapes[splatter.shape]);
                silhouetteCache.set(splatter.shape, silhouette);
            }
            paint.fill(silhouette);
            paint.restore();
        }
        this.pending.length = 0;
        ctx.drawImage(this.canvas, 0, 0, this.width, this.height);
    }
}
exports.PaintLayer = PaintLayer;
exports.paintLayer = new PaintLayer();
function popPaintBalloon(balloon) {
    exports.paintLayer.add(balloon);
}
//# sourceMappingURL=paintBalloon.js.map